module.exports = __webpack_public_path__ + "html/car-select.template.html";